import { BasePagedSearchCriteria } from "./BaseSearchCriteria";

export interface CameraSearchCriteria extends BasePagedSearchCriteria{

    name?:string;
}

export const CAMERA_SEARCH_CRITERIA_KEY = 'CameraSearchCriteria';